import { render, staticRenderFns } from "./migrationTasks.vue?vue&type=template&id=a4058650&scoped=true"
import script from "./migrationTasks.vue?vue&type=script&lang=js"
export * from "./migrationTasks.vue?vue&type=script&lang=js"
import style0 from "./migrationTasks.vue?vue&type=style&index=0&id=a4058650&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4058650",
  null
  
)

export default component.exports